<section class="page-hero footer-sections">
    <!--//End Header-->
    <div class="container">
        <h3 class="terms_title">VISOR HEALTH – CONSUMER HEALTH DATA PRIVACY POLICY </h3>
        <h6>Effective Date: June 1, 2026</h6>

        <div class="terms_content">
            <div class="block">
                <p>Note: This privacy policy applies to our collection, use, and disclosure of “Consumer Health Data”
                    received or created
                    due to your access to and use of certain items provided by us, “Visor Health, Inc.” (referred to
                    here as “Visor,” “we,”
                    “us,” or “our”). These items consist of our web-based and mobile applications, including but not
                    limited to CarePilot
                    and PT Copilot (collectively the “Application”). This policy applies to any personal information
                    that we collect that
                    may meet the definition of “Consumer Health Data” that is subject to state consumer health privacy
                    laws, including the
                    Washington State My Health My Data Act (“MHMDA”), and the Nevada Health Data Privacy Act (“NHDPA”).
                </p>

            </div>
            <div class="block">
                <strong>
                    <h5>Consumer Health Data We Collect </h5>
                </strong>
                <p>Because Consumer Health Data is defined very broadly, many of the categories of Application
                    Information (as defined in our Privacy Policy) that we collect could be considered “Consumer Health
                    Data”.
                </p>
                <p>Examples of Consumer Health Data may include: </p>
                <ul>
                    <li>Information about your health-related conditions, symptoms, status, diagnoses, testing, or
                        treatments (including surgeries, procedures, medications, or other interventions). For example,
                        we may collect such information through surveys or other communication with you for research
                        studies and improving product accessibility.</li>
                    <li>Measurements of bodily functions, vital signs, or characteristics, including photographs, which
                        may be considered biometric information applicable state consumer health privacy law. </li>
                    <li>Information that could identify your attempt to seek health care services or information,
                        including services that allow you to assess, measure, improve, or learn about your or another
                        person’s health, such as queries concerning nutrition, wellness, fitness, medical conditions, or
                        other health-related topics. </li>
                    <li>Other information that may be used to infer or derive data related to the above or other health
                        information. </li>
                </ul>
            </div>
            <div class="block">
                <strong>
                    <h5>Sources of Consumer Health Data</h5>
                </strong>
                <p>We collect Application Information (which may include Consumer Health Data) directly from you, from
                    your interactions with our Application. </p>
            </div>
            <div class="block">
                <strong>
                    <h5>Why We Collect and Use Consumer Health Data </h5>
                </strong>
                <p>We collect and use Consumer Health Data as reasonably necessary to provide you with the Application.
                    This may include delivering and operating the Application and its features, personalization of those
                    features, ensuring the secure and reliable operation of the Application and the systems that support
                    it, troubleshooting and improving the Application, and other essential business operations that
                    support the provision of the products (such as analyzing our performance, meeting our legal
                    obligations, developing our workforce, and conducting research and development). </p>
                <p>We may use Consumer Health Data for other purposes for which we give you choices and/or obtain your
                    consent as required by law. See the How to Exercise Your Rights section below for more details on
                    the controls and choices you may have. </p>
            </div>

            <div class="block">
                <strong>
                    <h5>Our Sharing of Consumer Health Data </h5>
                </strong>
                <p>We may share each of the categories of Consumer Health Data described above for the purposes
                    described in the “Application Information” section of our Privacy Policy. In particular, we may
                    share Application Information, including Consumer Health Data, with your consent or as reasonably
                    necessary to complete any transaction or provide the Application you have requested or authorized or
                    interacted with, as described above</p>
            </div>

            <div class="block">
                <strong>
                    <h5>Third Parties with whom we Share Consumer Health Data </h5>
                </strong>
                <p>As necessary for the purposes described above, we share Consumer Health Data with the following
                    categories of third parties: </p>
                <ul>
                    <li><b>Health Care Providers.</b> We share the Consumer Health Data that we collect from you with
                        the health care provider that enrolled you to use the Application. </li>
                    <li><b>Service Providers.</b> Vendors or agents (“Processors”) working on our behalf may access
                        Consumer Health Data for the purposes described above. For example, companies we’ve hired to
                        provide customer service support or assist in protecting and securing our systems and services
                        may need access to data to provide those functions.</li>
                    <li><b>Business Partners.</b> We may share Consumer Health Data with other companies, for example,
                        where you access Third-Party Materials through the Application.</li>
                    <li><b>Parties to a corporate transaction.</b> We may disclose Consumer Health Data as part of a
                        corporate transaction or proceeding such as a merger, financing, acquisition, bankruptcy,
                        dissolution, or a transfer, divestiture, or sale of all or a portion of our business or assets.
                    </li>
                    <li><b>Affiliates.</b> We enable access to data across our subsidiaries, affiliates, and related
                        companies, for example, where we share common data systems or where access helps us to provide
                        our services and operate our business. </li>
                    <li><b>Government agencies.</b> In certain cases, we may be obligated to disclose data to law
                        enforcement or other government agencies when we believe doing so is necessary to comply with
                        applicable law or respond to valid legal process. </li>
                    <li><b>Other third parties.</b> In certain circumstances, it may be necessary to provide data to
                        other third parties, for example, to comply with the law or to protect our rights or those of
                        our customers. </li>
                </ul>
            </div>

            <div class="block">
                <strong>
                    <h5>How to Exercise Your Rights</h5>
                </strong>
                <p>If you are covered by certain state laws, such as the MHMDA, the NHDPA, then you may have certain
                    rights with respect to Consumer Health Data, including rights to access, delete, or withdraw consent
                    relating to such data, subject to certain exceptions. You may exercise these rights as described in
                    the <b>“Your Personal Information Rights”</b> section of our Privacy Policy. You can always contact
                    us with questions by mail at 3723 Taylorsville Road, Suite B, Louisville KY 40220 or by email at
                    privacy&#64;visor.health, or by phone at +1 888 286 7181
                </p>
                <p>If your request to exercise a right is denied, you may appeal that decision by contacting us as
                    described above. If your appeal is unsuccessful, you can raise a concern or lodge a complaint with
                    the applicable regulatory authority. In Washington and Nevada, those officials are the Washington
                    State Attorney General at <a href="https://www.atg.wa.gov/file-complaint" target="_blank">https://www.atg.wa.gov/file-complaint</a>, or the Nevada State Attorney General
                    at <a href="https://ag.nv.gov/Complaints/CSU_Complaints___FAQ/" target="_blank">https://ag.nv.gov/Complaints/CSU_Complaints___FAQ/</a>. </p>
            </div>
        </div>
    </div>
</section>